import axios from "@axios";
import store from "@/store";
import { useUtils as useI18nUtils } from "@core/libs/i18n";

export default {
  namespaced: true,
  state: {
    items: [],
    brigadeUsers: [],
    brigadeStatus: [],
    brigadeRoles: [],
    brigadeUsers: [],
  },
  getters: {
    getItems(state) {
      return state.items;
    },
    getSelectedItems(state) {
      return state.items.map((brigade) => ({
        value: brigade.id,
        label: brigade.name,
      }));
    },
    getSelectedBrigadeUsersItems(state) {
      return state.brigadeUsers.map((user) => ({
        value: user.id,
        label: user.full_name + ' | ' + user.soeid,

        soeid: user.soeid,
        code_role: user.brigade_training?.role?.short_name ?? null,
        name_role: user.brigade_training?.role?.name ?? null,
        assignment_date: user.brigade_assignment?.assignment_date ?? null,
        assignment_status: user.brigade_assignment?.status_assignment ?? null,
        training_date: user.brigade_training?.training_date ?? null,
        training_type: user.brigade_training?.training_type ?? null,
        training_status: user.training_status ?? null,
      }));
    },
    getBrigadeUsersItems(state) {
      return state.brigadeUsers
        .filter(user => !user.brigade_assignment)
        .map((user) => ({
          value: user.id,
          label: user.full_name + ' | ' + user.soeid,

          soeid: user.soeid,
          code_role: user.brigade_training?.role?.short_name ?? null,
          name_role: user.brigade_training?.role?.name ?? null,
          assignment_date: user.brigade_assignment?.assignment_date ?? null,
          assignment_status: user.brigade_assignment?.status_assignment ?? null,
          training_date: user.brigade_training?.training_date ?? null,
          training_type: user.brigade_training?.training_type ?? null,
          training_status: user.training_status ?? null,
        }));
    },
    getSelectedBrigadeStatusItems(state) {
      return state.brigadeStatus.map((status) => ({
        value: status.id,
        label: status.name,
      }));
    },

    getSelectedBrigadeRolesItems(state) {
      return state.brigadeRoles.map((role) => ({
        value: role.id,
        label: role.name,
        code: role.short_name
      }));
    },
  },
  mutations: {
    setData(state, value) {
      state.items = value;
    },
    setBrigadeUsers(state, value) {
      state.brigadeUsers = value;
    },
    setBrigadeStatus(state, value) {
      state.brigadeStatus = value;
    },
    setBrigadeRoles(state, value) {
      state.brigadeRoles = value;
    },
  },
  actions: {
    async getAll({ commit }, params) {
      const response = await axios.get("v1/brigades", {
        params,
        responseType: params?.action == "export" ? "blob" : "json",
      });

      if (!response.data) {
        return [];
      }
      if (params?.action == "export") {
        const url = window.URL.createObjectURL(
          new Blob([response.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          response.headers["content-disposition"].split("filename=")[1]
        );
        document.body.appendChild(link);
        link.click();
        link.remove();
        const { t } = useI18nUtils();
        const notification = {
          id: response.headers["content-disposition"].split("filename=")[1],
          progress: 100,
          completed: true,
          view: "brigades",
          url: url,
          download: response.headers["content-disposition"].split("filename=")[1],
          title: "Reporte de Brigades",
          body: "Descarga completa",
          error: false,
          timestamp:
            new Date().toLocaleDateString() + " " + new Date().toLocaleTimeString(),
        };
        store.dispatch("grid/updateDownloadNotification", notification);
      } else {
        commit("setData", response.data.data);
        return response.data;
      }
    },
    async add(_, params) {
      const { data } = await axios.post("v1/brigades", params);
      return data;
    },
    async addWithFormData(_, { formData: fd }) {
      const { data } = await axios.post("v1/brigades", fd);
      return data;
    },
    async edit(_, { id, params }) {
      const { data } = await axios.put(`v1/brigades/${id}`, params)
      return data;
    },
    async editWithFormData(_, { id, formData: fd }) {
      const { data } = await axios.post(`v1/brigades/${id}`, fd);
      return data;
    },
    async delete(_, id) {
      const { data } = await axios.delete(`v1/brigades/${id}`);
      return data;
    },
    clear({ commit }) {
      commit("setData", []);
    },
    async getBrigadeUsers({ commit }) {
      const response = await axios.get("v1/users-rh");
      if (!response.data) {
        return [];
      }
      commit("setBrigadeUsers", response.data.data);
      return response.data;
    },
    async getBrigadeRoles({ commit }) {
      const response = await axios.get("v1/brigade-roles");
      if (!response.data) {
        return [];
      }
      commit("setBrigadeRoles", response.data.data);
      return response.data;
    },
    async getBrigadeStatus({ commit }) {
      const response = await axios.get("v1/brigades-status");
      if (!response.data) {
        return [];
      }
      commit("setBrigadeStatus", response.data.data);
      return response.data;
    },
  },
};
